/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { PureComponent } from 'react'

const Color = css`
  width: inherit;
  height: auto;
  .fill {
    fill: #acacac;
  }
`
export default class IdIco extends PureComponent {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="9" height="13" viewBox="0 0 9 13" css={Color}>
        <path id="합치기_131" className="fill" data-name="합치기 131" d="M.5,12a.5.5,0,0,1-.5-.5V9.026a4,4,0,0,1,8,0V11.5a.5.5,0,0,1-.5.5ZM1.629,2.372A2.371,2.371,0,1,1,4,4.743,2.374,2.374,0,0,1,1.629,2.372Z" transform="translate(0.5 0.5)" fill="#2c346a" stroke="rgba(0,0,0,0)" strokeMiterlimit="10" strokeWidth="1"/>
      </svg>

    )
  }
}
